import { Injectable, Optional } from "@angular/core";
import { ProtocolTableService } from 'app.services/protocol.table/services/protocol.table.service';
import * as moment from "moment";
import { ISessionWorklistData } from "../../../app/shell/session/interfaces/isession";
import { SessionWorklistDataService } from "../../../app/shell/session/session.container/services/session.worklist.data.service";
import { Serialization } from "../../../common/http/utils/serialization";
import { LogCat, LogManager } from "../../../common/log";
import { TypeHelper } from "../../../common/utils/type.helper";
import { Sps } from "../order/models/sps";
import { Patient } from "../patient/models/patient";
import { ClinicalStatusService } from "./clinical.status.service";

/**
 * Created by stanislavk on 19/03/2017.
 */

@Injectable({ providedIn: 'root' })
  export class PatientResponseService {
	//The protocoTableService is optional because the Patient Portal and Patient Kiosk do not use it.
		constructor(private clinicalStatusService:ClinicalStatusService,
				private sessionWorklistDataService:SessionWorklistDataService,
				@Optional() protected protocolTableService:ProtocolTableService) { }

	/**
	 * Changes the prototype of patient object returned from server.
	 * @param res Patient object returned from server.
     */
	public patientResponseProcess(res:Patient) {
		if (res) {
			Serialization.convertDateStringsToDates(res,new RegExp(".*"));
			TypeHelper.changePrototype(res, Patient);

			// filter out cancelled sps
			if (res.visit) {
				res.visit.forEach(visit => {
					if (visit.orders) {
						visit.orders.forEach(order => {
							if (order.requestedProcedure) {
								order.requestedProcedure.forEach(rp => {
									if (rp.sps && rp.sps.length) {
										rp.sps = rp.sps.filter(sps => !this.isCancelledSps(sps));
									}
								});
							}
						});
					}
				});
			}
			this.protocolTableService?.addMissingProtocolTables(res);
			this.filterConferenceXWorklistRows(res);
		}
	}

	public isCancelledSps(sps:Sps) : boolean {
		return (this.clinicalStatusService.isCancelledClinicalObject(sps) || (sps.spsXPps && sps.spsXPps.length &&
			sps.spsXPps[0].pps && sps.spsXPps[0].pps.length &&
			this.clinicalStatusService.isCancelledClinicalObject(sps.spsXPps[0].pps[0])));
	}

	/**
	 * In case opening the session from conference worklist we filter the conferenceXWorklist by siteWorklistKey, conference Key and conference date.
	 */
	public filterConferenceXWorklistRows(res:Patient) {
		if (res.conferenceXWorklist && res.conferenceXWorklist.length > 0) {
			let isFilterRows: boolean = false;
			let sessionWorklistData: ISessionWorklistData = this.sessionWorklistDataService.worklistDataSubject.getValue();
			if (sessionWorklistData) {
				LogManager.debug(LogCat.Session.WorklistData,
					"filterConferenceXWorklistRowsByConferenceKey start with sessionWorklistData:", sessionWorklistData);
				let conferenceKey = sessionWorklistData.conferenceKey;
				if (conferenceKey) {
					let siteWorklistKey = sessionWorklistData.siteWorklistKey;
					let conferenceDate = sessionWorklistData.conferenceDate;
					res.conferenceXWorklist = res.conferenceXWorklist.filter(x =>
						x.conferenceKey === conferenceKey &&
						x.siteWorklistKey === siteWorklistKey &&
						(conferenceDate ? (moment(x.effectiveDate).isSame(conferenceDate, "day")) : true));

					isFilterRows = true;
				}
			}

			if (!isFilterRows) {
				res.conferenceXWorklist = [];
			}
		}
	}

}

